// extracted by mini-css-extract-plugin
export var markdown = "_uy-0";
export var tableWrapper = "_uy-1";